//////////////////////////////////////////////////////////////////////
//
//  10/02/18
//  src/store/actions/navbar.js
//
//  This file contains the 'navbar' actions.
//

import { NAV_CKBOX_CH, NAV_TOPST_CH, NAV_BOTH_CH } from "../actionTypes";

// This is what we will 'dispatch' and send to our 'navbar' reducer.
const changeCkBox = ckBox => ({
  type : NAV_CKBOX_CH,
  ckBox
});

// Function to call to dispatch change to the Check Boxes.
export function setCkBox( str ) {
  return dispatch => {
    dispatch( changeCkBox( str ) );
  };
}

// This is what we will 'dispatch' and send to our 'navbar' reducer.
const changeTopSt = topSt => ({
  type : NAV_TOPST_CH,
  topSt
});

// Function to call to dispatch change to the Top Nav Bar.
export function setTopSt( str ) {
  return dispatch => {
    dispatch( changeTopSt( str ) );
  };
}

// This is what we will 'dispatch' and send to our 'navbar' reducer.
const changeBoth = ( topSt, sCat ) => ({
  type : NAV_BOTH_CH,
  topSt,
  sCat
});

// Function to call to dispatch change to the Top Nav Bar.
export function setBoth( topSt, sCat ) {
  return dispatch => {
    dispatch( changeBoth( topSt, sCat ) );
  };
}




// WEBPACK FOOTER //
// ./src/store/actions/navbar.js